module.exports = __webpack_public_path__ + "img/10备份 5.0f6bbc4f.jpg";